import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import fallbackLogo from '../../pbs-logo.svg'
import { useLocation } from 'react-router'

const LogoHeader = (props) => {
  const location = useLocation()
  const showLogoBackground = ['/home', '/shows'].includes(location?.pathname)

  return (
    <div className="logo-header">
      {showLogoBackground && <div className="logo-header__background"></div>}
      <img
        className="station-logo"
        src={props.cobrandLogo ? props.cobrandLogo : fallbackLogo}
        alt={`${props.alt} logo`}
      />
    </div>
  )
}

LogoHeader.propTypes = {
  alt: PropTypes.string,
  cobrandLogo: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    cobrandLogo: state?.station?.white_cobranded_logo,
    alt: state?.station?.station_title,
  }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  LogoHeader
)
